var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3414 30.9364L34.4055 23.9986H27.7488V19.4964C27.7488 17.5984 28.6787 15.7483 31.6602 15.7483H34.6868V9.84182C34.6868 9.84182 31.94 9.37305 29.3141 9.37305C23.8316 9.37305 20.2484 12.6957 20.2484 18.7109V23.9986H14.1543V30.9364H20.2484V47.708C21.4704 47.8997 22.7228 47.9996 23.9986 47.9996C25.2744 47.9996 26.5269 47.8997 27.7488 47.708V30.9364H33.3414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.045c8ee85f32f86a5bf76995df684e28.svg";
export { ForwardRef as ReactComponent };